// Generics
import genericSubtask from './subtasks/generic-subtask'
import { TASK_TYPE } from '@/views/feed/constants/defaults'

// Subtasks
import GutenbergReachout from './subtasks/gutenberg_reachout.json'
import PendingPrescription from './subtasks/pending_prescription.json'
import SessionDone from './subtasks/session_done.json'
import UpcomingCall from './subtasks/upcoming_call.json'
import ProtocolProgression from './subtasks/protocol_progression/protocol_progression.thrive.json'
import ProtocolProgressionBloom from './subtasks/protocol_progression/protocol_progression.bloom.json'
import PendingResistancePrescription from './subtasks/pending_resistance_prescription.json'
import PendingExclusion from './subtasks/pending_exclusion.json'
import AcademySuggestion from './subtasks/academy_suggestion.json'
import ProblematicReassessment from './subtasks/problematic_reassessment.json'
import ReferralRejection from './subtasks/referral_rejection.json'

// Subtask Groups
import ProblematicSession from './subtasks-groups/problematic_session.json'

const emptyTaskObject = { data: { empty_data: 'No data available' } }

const taskinhaMap = {
  session_done: genericSubtask(TASK_TYPE.SESSION_DONE, SessionDone),
  pending_prescription: genericSubtask(TASK_TYPE.PENDING_PRESCRIPTION_V2, PendingPrescription),
  gutenberg_reachout: genericSubtask(TASK_TYPE.REACH_OUT, GutenbergReachout),
  upcoming_call: genericSubtask(TASK_TYPE.UPCOMING_CALL, UpcomingCall),
  protocol_progression: genericSubtask(TASK_TYPE.PROTOCOL_PROGRESSION, ProtocolProgression),
  'protocol_progression:bloom': genericSubtask(TASK_TYPE.PROTOCOL_PROGRESSION, ProtocolProgressionBloom),
  pending_resistance_prescription: genericSubtask(TASK_TYPE.PENDING_RESISTANCE_PRESCRIPTION, PendingResistancePrescription),
  plan_of_care: genericSubtask(TASK_TYPE.PLAN_OF_CARE, emptyTaskObject),
  pending_reply: genericSubtask(TASK_TYPE.PENDING_REPLY, emptyTaskObject),
  pending_exclusion: genericSubtask(TASK_TYPE.PENDING_EXCLUSION, PendingExclusion),
  academy_suggestion: genericSubtask(TASK_TYPE.ACADEMY_SUGGESTION, AcademySuggestion),
  problematic_reassessment: genericSubtask(TASK_TYPE.PROBLEMATIC_REASSESSMENT, ProblematicReassessment),
  follow_up_prescription: genericSubtask(TASK_TYPE.FOLLOW_UP_PRESCRIPTION, emptyTaskObject),
  referral_rejection: genericSubtask(TASK_TYPE.CLINICAL_REFERRAL_REJECTION, ReferralRejection),
} as const

const taskinhaGroupsMap = {
  problematic_session: ProblematicSession,
}

type TaskinhaMapKeys = keyof typeof taskinhaMap
type MasterTaskMockGroupsTypes = keyof typeof taskinhaGroupsMap

export default function MasterTaskMock(tasksToMock: TaskinhaMapKeys[] = [], groupsToMock: MasterTaskMockGroupsTypes[] = []) {
  const taskinhas = tasksToMock.map((taskType) => taskinhaMap[taskType])
  const taskinhaGroups = groupsToMock.map((groupType) => taskinhaGroupsMap[groupType])

  return {
    task: {
      id: 1567,
      patient_id: 14373,
      program_uuid: 'f13cc925-66f7-4773-93ab-af43126c7801',
      account_uuid: 'f34baa7d-5290-11f0-9f6d-e6c8ececd789',
      scoring_algorithm_id: 8,
      score_value: 57.15,
      assignee_id: 7273,
      status: 'pending',
      unit: 'move',
      newsfeed: [],
      taskinhas,
      taskinha_groups: taskinhaGroups,
      snooze_options: [1, 3, 8, 24],
    },
  }
}
